import React  from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import SideModal from '/src/components/modal/SideModal/SideModal'
import useModalHelper from "/src/components/modal/hooks/useModalHelper";

import RoleModalBody from "./RoleModalBody.js"


const RoleModal = NiceModal.create(({ title, data , type }) => {
  

    const modal = useModal();

    const { onClose } = useModalHelper(modal);


    
   
    return (
        <SideModal name="change-password" id={modal.id} autoClose="true" onClose={onClose}>
            <div>
                <div className="button-leave" id="close_modal_container" onClick={() => onClose({ idIconModal: "close_modal_container" })}  >
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
           
             <RoleModalBody data={data}  type={type} ></RoleModalBody>
               
        </SideModal >
    )
});

export default RoleModal;